import * as React from "react";
import { I18n } from "react-redux-i18n";

import { QuestionnaireUpdateLocalDto } from "@modules/fhq-design-tool/dto/questionnaire-update-local-dto";
import { Flex } from "@common/components/Flex";
import { QuestionnaireManagementErrors } from "@modules/fhq-design-tool/controllers/questionnaire-validation";

import { TextField } from "../../../text-field";
import { Title } from "../../../title";
import { QuestionnaireCreateLocalDto } from "@modules/fhq-design-tool/dto/questionnaire-create-local-dto";

import "./email-notify-on-submit.styles.scss";

type EmailNotifyOnSubmitProps = {
  questionnaire: QuestionnaireUpdateLocalDto | QuestionnaireCreateLocalDto;
  onChange: (questionnaire: QuestionnaireUpdateLocalDto | QuestionnaireCreateLocalDto) => void;
  errors?: QuestionnaireManagementErrors
};

export const EmailNotifyOnSubmit: React.FC<EmailNotifyOnSubmitProps> = (props) => {
  const { questionnaire, onChange, errors } = props;

  const handleChange = React.useCallback(
    (changedValue: string) => {
      onChange({
        ...questionnaire,
        emailsTab: {
          ...questionnaire.emailsTab,
          emailNotifyOnSubmit: changedValue.trim(),
        },
      });
    },
    [questionnaire, onChange]
  );

  return (
    <div className="FhqDesignToolEmailToNotify">
      <Flex>
        <Title margin="0" text={I18n.t("Email to notify questionnaire submitted")}  />
        <TextField
          className="FhqDesignToolEmailToNotify__field"
          errors={errors?.properties?.emailNotifyOnSubmit}
          metadata={{
            description: "email-notify-on-submit",
          }}
          value={questionnaire.emailsTab.emailNotifyOnSubmit ?? ''}
          onChange={handleChange}
          placeholder="email1@example.com, email2@example.com"
        />
      </Flex>
    </div>
  );
};
